/* eslint-disable */
/*
Notes: we should combine code from CreatePostSaga and EditPostScreen into PostSagas.js.
Right now we have three sets of code, each screen choosing which to use.
*/

import { all, call, put, fork, take } from 'redux-saga/effects'
import { path } from 'ramda'
//import RNFetchBlob from "react-native-fetch-blob"
import EventEmitter from 'EventEmitter'

import CreatePostActions from '../Redux/CreatePostRedux'

const MEDIA_STILL    = 'JPEG'
const MEDIA_VIDEO    = 'MP4'
const MEDIA_VIDEO_3D = '3D'
const MEDIA_TYPES    = [MEDIA_STILL, MEDIA_VIDEO, MEDIA_VIDEO_3D]

const delay = (ms) => new Promise(res => setTimeout(res, ms))

const s3Upload = (details) => {
  console.tron.display({
    name: 's3Upload',
    preview: 'details',
    value: {
      presignedUrl: details.presignedUrl,
      // details: details
    }
  })
  const headers = {
    'Content-Type' : 'application/octet-stream',
  }
  // https://github.com/joltup/react-native-fetch-blob
  if (details.base64 && false)
    return RNFetchBlob.fetch('PUT', details.presignedUrl, headers, details.base64)
      .uploadProgress({ interval : details.interval },(written, total) => {
      })
  else
    if (false)
    return RNFetchBlob.fetch('PUT', details.presignedUrl, headers, RNFetchBlob.wrap(details.uri))
      .uploadProgress({ interval : details.interval },(written, total) => {
      })
}

const responseToError = (response, title) => {
  console.tron.display({
    name: 'OrderSagas',
    preview: title,
    value: {
      response: response
    }
  })
  const apiResponse = typeof response.data != 'undefined' ? response.data : null
  const result = {
    error: {
      httpCode: response.status, // response.respInfo.status
      code:     typeof apiResponse.errors != 'undefined' ? apiResponse.errors[0]['code'] : -1,
      title:    title,
      detail:   typeof apiResponse.errors != 'undefined' ? apiResponse.errors[0]['detail'] : "Unknown",
    },
    logRef: typeof apiResponse.logRef != 'undefined' ? apiResponse.logRef : null
  }
  return result
} // responseToError

export const createOptions = function* createOptions(api, action) {
  // do nothing, just for debug BasePostWall options
  yield put(CreatePostActions.createOptionsSuccess({}))
}

export const createRepost = function* createRepost(api, action) {
  // Note: current API has a bug which wipes out caption, location, tags, etc
  try {
    const { postId, post } = action
    const response = yield call(api.repost, postId, post)
    if (response.ok) {
      const apiResponse = response.data
      const post = apiResponse.data[0]
      yield put(CreatePostActions.createSuccess(post))
    }
    else {
      yield put(CreatePostActions.createFailure(responseToError(response, "Repost Exception").error.detail))
    }
  }
  catch (e) {
    yield put(CreatePostActions.createFailure("Repost Exception: " + e.message))
    console.tron.display({
      name: 'createRepost',
      preview: "error",
      value: {
        message: e.message,
        e: e
      }
    })
  }
} // createRepost

export const createPost = function* createPost(api, action) {
  console.tron.log("CreatePostSagas createPost start")
  try {
    yield put(CreatePostActions.createProgress(0.1/2 + 0.5))
    const { post, files } = action

    if (files.length < 2) {
      yield put(CreatePostActions.createFailure("Unable to create post, too few files: " + files.length))
      return;
    }
    if (typeof post.AspectRatio == 'undefined' || isNaN(parseFloat(post.AspectRatio)) || post.AspectRatio <= 0) {
      yield put(CreatePostActions.createFailure("Unable to create post, Post aspect ratio invalid"))
      return
    }
    if (typeof post.MediaType == 'undefined' || MEDIA_TYPES.indexOf(post.MediaType) == -1) {
      yield put(CreatePostActions.createFailure("Unable to create post, MediaType is invalid"))
      return
    }

/*
    const ziggystardustOfferId = Math.random() < 0.5 ?
      'AS5758b527028b600001ac1f18a32d6c-1565142067.123388' : // Cactus Club
      'AS5758b527028b600001ac1f18a32d6c-1565386740.131237' // Red Robin
    const postExtra = Object.assign({}, post, {OfferIdsOnCompletion: ziggystardustOfferId})
*/

    const newPostResponse = yield call(api.createPost, post)
    if (!newPostResponse.ok) {
      // ****** TODO ****** error checking for post call...
      console.tron.display({
        name: 'CreatePostSagas',
        preview: 'createPost response failed',
        value: {
          newPostResponse: newPostResponse
        }
      })
      let httpCode   = ''
      let logRef     = 'unknown'
      let errMessage = ''
      try {
        httpCode   = newPostResponse.data.httpCode
        logRef     = newPostResponse.data.logRef
        errMessage = newPostResponse.data.errors[0].detail
      }
      catch (e) {
      }
      yield put(CreatePostActions.createFailure(`Unable to create post, record creation failed. httpCode ${httpCode}, logRef: ${logRef}, message: ${errMessage}`))
      return;
    }
    yield put(CreatePostActions.createProgress(0.2/2 + 0.5))

    console.tron.log("CreatePostSagas createPost response ok")
    const apiResponse = newPostResponse.data
    const detail      = apiResponse.data[0]
    const postId      = detail.PostId

    let detailedFiles = files.concat() // clone
    const fileCount = detailedFiles.length
    for (let i = 0; i < fileCount; i++) {
      switch (detailedFiles[i].kind) {
        case 'thumbImage': detailedFiles[i].presignedUrl = detail.thumbImage._url; break;
        case 'thumbVideo': detailedFiles[i].presignedUrl = detail.thumbVideo._url; break;
        case 'tileVideo':  detailedFiles[i].presignedUrl = detail.tileVideo._url;  break;
        case 'image':      detailedFiles[i].presignedUrl = detail.image._url;      break;
        case 'video':      detailedFiles[i].presignedUrl = detail.video._url;      break;
        default:
          yield call(api.deletePost, postId)
          yield put(CreatePostActions.createFailure("Unknown file kind: " + detailedFiles[i].kind))
          return
      }
      detailedFiles[i].interval = 500; // future progress update rate in ms
    }

    console.tron.log("Calling upload for post files")
    let eTagList = []
    for (let index = 0; index < fileCount; index++) {
      const uploadResponse = yield call(s3Upload, detailedFiles[index])
      if (uploadResponse.respInfo.status != 200) {
        // try again after a small delay?
        yield call(api.deletePost, postId)
        yield put(CreatePostActions.createFailure("Unable to create post, one of the files (" + detailedFiles[index].kind +  ") failed to upload"))
        return
      }
      eTagList.push(uploadResponse.respInfo.headers.Etag)
      yield put(CreatePostActions.createProgress(0.2/2 + (0.5 / fileCount) * (index + 1))/2 + 0.5) // between 0.2 and 0.7
      console.tron.log("Finished " + detailedFiles[index].kind)
    }
    console.tron.log("All files uploaded")

    // leave some time for files to show up on the api's s3 server
    yield delay(1000)
    console.tron.log("after 1000ms delay")
    yield put(CreatePostActions.createProgress(0.8/2 + 0.5))

    let tries = 0
    let allFilesPresent = false
    do {
      const fileListResponse = yield call(api.listPostFiles, postId)
      console.tron.display({
        name: 'CreatePostSagas',
        preview: 'createPost fileListResponse',
        value: {
          fileListResponse: fileListResponse
        }
      })
      if (!fileListResponse.ok) {
        console.tron.log("CreatePostSagas createPost listPostFiles failed")
        yield call(api.deletePost, postId)
        yield put(CreatePostActions.createFailure("Unable to create post, could not list files on server"))
        return
      }
      const serverFiles = fileListResponse.data.data
      allFilesPresent = eTagList.length == serverFiles.length
      for (let i = 0; i < serverFiles.length; i++)
        if (eTagList.indexOf(serverFiles[i].ETag) == -1)
          allFilesPresent = false;
      if (!allFilesPresent) {
        console.tron.log("files not seen by api yet, delay 2s")
        yield delay(2000)
      }
      tries++
      console.tron.log("fileListResponse tries: " + tries + ", present: " + allFilesPresent)
    } while (!allFilesPresent && tries < 10)
    yield put(CreatePostActions.createProgress(0.9/2 + 0.5))

    if (!allFilesPresent) {
      console.tron.log("CreatePostSagas createPost files never showed up")
      yield call(api.deletePost, postId)
      yield put(CreatePostActions.createFailure("Unable to create post, files did not show up at server"))
      return
    }

    const finishPostResponse = yield call(api.finishPost, postId)
    if (finishPostResponse.ok) {
      console.tron.log("CreatePostSagas createPost post was completed")
      const apiResponse = finishPostResponse.data
      const post = apiResponse.data[0]
      yield put(CreatePostActions.createSuccess(post))
    }
    else {
      console.tron.log("CreatePostSagas createPost finishPost failed")
      yield call(api.deletePost, postId)
      yield put(CreatePostActions.createFailure("Unable to create post, could not finalize record"))
    }

  }
  catch (e) {
    console.tron.display({
      name: 'CreatePostSagas',
      preview: "error",
      value: {
        message: e.message,
        e: e
      }
    })
    yield put(CreatePostActions.createFailure("Unable to create post"))
  }
}
